module.exports = __webpack_public_path__ + "media/images/best_concept-s-8b99bbe2376ec699d3973f5c945d4123.png";